<template>
  <div class="control-sliders" style="width:100%;">
    <div style="padding:10px 10px 10px 10px; margin:0px 10px 10px 10px; height:100%; max-height:100%;">
        <div class="row no-gutter" style="height: 60px;background:white;border-radius:4px; border-left: #f5f5f5 4px solid;border-right: #f5f5f5 4px solid;">
            <div class="col-md-4">
                <div style="padding:10px; height:60px; padding-top:14px">
                    <at-button-group>
                        <at-button size="medium" class="dark-border-col"  icon="icon-stop-circle" @click="firstFrame"></at-button>
                        <at-button class="left-align brandColor border-col"
                        size="medium" type="primary" icon="icon-play" @click="playOrPause"></at-button>
                        <at-button size="medium" class="dark-border-col" icon="icon-chevron-right" @click="lastFrame" ></at-button>
                    </at-button-group>
                </div>
            </div>
            <div class="col-md-20">
                <div style="padding:10px 0px 10px 0px; height:60px">
                    <vue-slider class="is-progress-slider inline is-vertical-mid" 
                    v-model="playBackCur" width="90%"
                    :tooltip-style="{'background-color': '#526780'}"
                    :process-style="{'background-color': '#526780'}" 
                    :duration="0" v-on:change="onPlaybackChange"
                    :min="playBackMinMax[0]" :max="playBackMinMax[1]"
                    :contained="true" :adsorb="true" :marks="secMark"  
                    :tooltip-placement="'top'" :tooltip-formatter="'frame {value}'">
                    </vue-slider>
                </div>
            </div>
        </div>

        <MotionSliders  v-bind:bezieAppObj="bezieAppObj"/>
        
    </div>
  </div>
</template>

<script>
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';
import MotionSliders from './MotionSliders.vue';
import { BObject } from '../../lib/bezieLib/Objects/BObject';
import { BezieApp } from '../../lib/bezieLib/BezieApp';

export default {
    name: 'ControlSliders',
    props: { bezieAppObj : BezieApp },
    components: {MotionSliders},
    data: function(){
        return{
            playBackMinMax : [0,100],
            playBackCur : 0,
            fps: 24,
            scene: null,
            secMark: val => val % this.fps === 0 ? ({
                    label: `${val/this.fps}s`,
                    labelStyle: { color: 'grey'}
                    }) : val % (this.fps/4) === 0 ? ({label: ``}) : false
        }
    },
    watch: {
        bezieAppObj : function(val){
            console.log("loaded bezie app obj in controlslider val:"+val);
            this.init();
        }
    },
    methods:{
        onPlaybackChange: function(val){
            if(this.scene){
                this.scene.setCurFrame(this.playBackCur);
            }
        },
        playOrPause: function(event){
            console.log("play or pause");
            if(this.bezieAppObj){
                this.bezieAppObj.playOrPause();
            }
        },
        firstFrame: function(event){
            console.log("stop playback. showing first frame");
            if(this.bezieAppObj){
                this.bezieAppObj.stop();
            }
        },
        lastFrame: function(event){
            console.log("stop playback. showing last frame");
            if(this.bezieAppObj){
                this.bezieAppObj.stop();
                this.bezieAppObj.getScene().setCurFrame(this.playBackMinMax[1]);
            }
        },
        onUpdate : function(curFrame){
            console.log("frame: "+curFrame);
            this.playBackCur = curFrame;
        },
        onTotalFramesChange: function(totalFrames){
            if(this.bezieAppObj){
                this.playBackMinMax = this.bezieAppObj.getScene().getFrameRange();
            }
        },
        init: function(){
            if(this.bezieAppObj){
                this.fps = this.bezieAppObj.getFps();
                this.scene = this.bezieAppObj.getScene();
                if(this.scene){
                    this.playBackMinMax = this.scene.getFrameRange();
                    this.playBackCur = this.scene.getCurFrame();
                }
                console.log("adding playback listener");
                UIUpdate.addPlaybackUpdateListener(this);
            }
        }
    },
    mounted: function(){
        console.log("control slider mounted");
        this.init();
    },
    beforeDestroy: function(){
        if(this.bezieAppObj){
            console.log("removing playback listener");
            UIUpdate.removePlaybackUpdateListener(this);
        }
    }
}
</script>

<style>

.is-progress-slider{
  margin: 5px 12px 5px 12px;
}


.left-align{
    text-align: left;
}

.border-col{
    border-color: #f18138 !important
}

.dark-border-col{
    border-color: silver !important
}

.inline{
    display:inline-block;
}

.is-slider{
     width:80%
}

.is-vertical-mid{
    vertical-align: middle
}

.is-left-col{
    width: 120px;
}
</style>
